import register from '@kpsys/angularjs-register';
import OpeningCalendarDataService from './kp-opening-calendar.data-service';

export default register('portaro.shared.components.opening-calendar')
    .service(OpeningCalendarDataService.serviceName, OpeningCalendarDataService)
    .value('openingCalendarApiUrl', 'opening-calendar')
    .name();